







































































import getCraftPages from '~/queries/craft-pages.gql'
import getRelatedPosts from '~/queries/related-posts.gql'
import pageMixin from '@bkwld/cloak/mixins/page'
import { makeJsonLdArticleTag } from '@bkwld/json-ld-formatters'

export default
	name: 'Recipe'

	mixins: [ pageMixin ]

	data: ->
		filteredCategory: null
		selectedCards: []

	# Structured meta
	head: -> {
		...@buildHead
			image: (image = @$makeImgixUrl @page.listingImage[0]?.path)
		script: [ makeJsonLdArticleTag
			title: @page.title
			image: image
			publishedAt: new Date @page.dateCreated
			updatedAt: new Date @page.dateUpdated
			author: "California Olive Ranch"
		]
	}

	# Get Tower data
	asyncData: ({ app, store, route, payload }) ->
		# Get data
		[ page ] = payload || await app.$craft.getEntries
			query: getCraftPages
			variables:
				section: 'recipes'
				type: 'template'
				uri: route.path.substr(1)
		return app.$notFound() unless page

		category = page?.category?[0]

		# Get 3 other blogs besides the current recipe
		relatedPosts = await app.$craft.getEntries
			query: getRelatedPosts
			variables:
				section: 'recipes'
				exclude: page.id
				category: category?.id
				limit: 4

		# Set data
		return {
			page
			relatedPosts
		}

	computed:

		mainCategory: -> @page?.category?[0]

		breadcrumbLinks: ->
			links = [
				{
					text: "Recipes"
					href: "/recipes"
				}
			]

			if @mainCategory then links.push
				text: @mainCategory?.title
				href: "/recipes/#{@mainCategory?.slug}"

			return links

		relatedProductsBlock: ->
			# Show products tagged with the "Featured" category
			categories: [ {"id": '23091'} ]
			products: []

		cardBlock: ->
			cardGroups: [
				{
					cards: @postsCards
				}
			]

		postsCards: ->
			@relatedPosts.map (post) ->
				image: post.listingImage
				title: post.title
				href: "/#{post.uri}"

	watch:
		filteredCategory: (id) ->
			@selectedCards = @buildPostsCards id


